<template>
  <main role="NegoisasiDetail">
    <div class="row">
      <!-- PLACEHOLDER -->
      <div class="col-md-8 forPlaceholder">
        <div class="card">
          <div class="card-header">
            <h5 class="card-title">Detail Negoisasi</h5>
          </div>
          <div class="card-body">
            <content-placeholders :animated="false">
              <content-placeholders-heading :img="true" />
              <content-placeholders-text :lines="3" />
              <content-placeholders-heading :img="true" />
              <content-placeholders-text :lines="3" />
            </content-placeholders>
          </div>
        </div>
      </div>

      <div class="col-md-4 forPlaceholder">
        <div class="card">
          <div class="card-header">
            <h5 class="card-title">Customer</h5>
          </div>
          <div class="card-body">
            <content-placeholders :animated="false">
              <content-placeholders-heading :img="true" />
              <content-placeholders-text :lines="3" />
            </content-placeholders>
          </div>
        </div>
      </div>
      <!-- END PLACEHOLDER -->

      <!-- MODAL -->
      <div
        class="modal fixed-left fade"
        tabindex="-1"
        id="modal-sepakat"
        role="dialog"
      >
        <div
          class="modal-dialog right modal-lg modal-dialog-aside"
          role="document"
        >
          <div
            class="modal-content"
            style="background-color: rgb(240, 240, 240)"
          >
            <div class="modal-header">
              <h5 class="card-title">Tanggapan</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="card-on-card">
                <div class="col-md-12">
                  <div class="card-body">
                    <form action="" id="form_sepakat" method="post">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Harga Satuan</label>
                            <CurrencyInput
                              :value="modalRespond.priceUnit"
                              class="form-control"
                              id="harga_satuan"
                              readonly=""
                            />
                            <!-- <input class="form-control" type="text" placeholder="Masukkan nilai sepakat" name="harga"
                              id="harga" :value="modalRespond.priceUnit" readonly="" /> -->
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Qty</label>
                            <input
                              class="form-control"
                              type="text"
                              placeholder="Masukkan nilai sepakat"
                              name="qty"
                              :value="modalRespond.qty"
                              readonly=""
                            />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>TOP ( Term Of Payment)</label>
                            <input
                              class="form-control"
                              type="text"
                              name="top"
                              :value="modalRespond.termOfPayment"
                              readonly=""
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Kurir</label>
                            <input
                              class="form-control"
                              type="text"
                              name="kurir"
                              :value="modalRespond.shippingName"
                              readonly=""
                            />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Pembungkus</label>
                            <input
                              class="form-control"
                              readonly
                              type="text"
                              placeholder="Masukkan pembungkus"
                              name="pembungkus"
                              :value="modalRespond.wrappingName"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Biaya Pembungkus</label>
                            <input
                              class="form-control"
                              type="text"
                              placeholder="Masukkan biaya pembungkus"
                              id="pembungkus_fee"
                              :value="modalRespond.wrappingPrice"
                              name="pembungkus_fee"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Asuransi</label>
                            <input
                              class="form-control"
                              type="text"
                              name="asuransi"
                              readonly
                              :value="modalRespond.insurance"
                            />
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label>% Asuransi</label>
                            <select
                              name="asuransi_persen"
                              class="form-control custom-select"
                              id="asuransi_persen"
                            >
                              <option
                                v-for="(
                                  asr, index
                                ) in modalRespond.insuranceOptions"
                                :key="index"
                                :value="asr.value"
                              >
                                {{ asr.label }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label>Biaya Asuransi</label>
                            <input
                              class="form-control"
                              type="text"
                              :value="modalRespond.insurancePrice"
                              placeholder="Masukkan biaya asuransi"
                              name="asuransi_fee"
                              id="asuransi_fee"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label>Harga Tanggapi</label>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <label class="input-group-text">Rp.</label>
                          </div>
                          <CurrencyInput
                            ref="harga_tanggapi"
                            v-model="dataValue"
                            :value="
                              checkedData
                                ? (dataValue = Number(modalRespond.priceUnit))
                                : dataValue
                            "
                            :disabled="checkedData ? true : false"
                            class="form-control"
                            id="harga_tanggapi"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label>Catatan</label>
                        <textarea
                          placeholder="Tulis Catatan..."
                          class="form-control"
                          rows="2"
                          name="spek"
                          id="otherSpec"
                        ></textarea>
                      </div>
                      <div class="form-group">
                        <label class="text-danger">
                          <input
                            class="mr-2"
                            type="checkbox"
                            name="sepakat"
                            id="ceklisSepakat"
                            @change="checkSepakat($event)"
                            v-model="checkedData"
                          />
                          <i
                            class="fa fa-arrow-left small"
                            aria-hidden="true"
                          ></i>
                          Centang jika setuju</label
                        >
                        <br />
                        <span
                          >Note: Jika sudah setuju maka tidak ada negoisasi
                          antara pembeli dan penjual</span
                        >
                      </div>
                    </form>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    id="respondNego"
                    @click="respondNego"
                    class="btn btn-info"
                  >
                    Kirimkan Penawaran
                  </button>
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END MODAL -->

      <div class="col-md-8 dataCard">
        <div class="card">
          <div class="card-header">
            <a
              :href="parentData.downloadRecap"
              target="_blank"
              class="btn btn-dark pull-right"
              ><i class="fa fa-cloud-download" aria-hidden="true"></i> Download
              Rekap Negoisasi</a
            >
            <h5
              class="text-truncate card-title"
              style="font-size: 15px; max-width: 50%"
            >
              Detail Negoisasi {{ product.name }}
            </h5>
          </div>
          <div class="card-body">
            <div class="card-on-card mb-3">
              <div class="row no-gutters p-5">
                <div class="col-md-4">
                  <img
                    :src="product.image"
                    class="img-container"
                    alt=""
                    width="170px"
                  />
                </div>
                <div class="col-md-8">
                  <div class="card-body">
                    <h5 class="card-title">Barang Yang di Nego</h5>
                    <h5 class="card-title">{{ product.name }}</h5>
                    <p class="card-text">
                      Harga Satuan :
                      {{ product.priceUnitCurrencyFormat }}
                      <b>{{ product.zone }}</b>
                    </p>
                    <p class="card-text">
                      Harga Total :
                      {{ product.totalPriceUnitCurrencyFormat }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-on-card mb-3">
              <div v-if="parentData.isReject" class="alert alert-danger">
                <template v-if="parentData.isRespondFrom === 'penyedia'">
                  <i
                    class="fa fa-exclamation-circle mr-2"
                    aria-hidden="true"
                  ></i>
                  <span class="" style="font-size: 13px; font-weight: 500"
                    >Penyedia menolak negosiasi<br class="mb-2"
                  /></span>
                  <!-- <span class="" style="font-size: 12px">
                    Sekolah tidak dapat menambahkan produk ke keranjang</span
                  > -->
                </template>

                <template v-if="parentData.isRespondFrom === 'satdik'">
                  <i
                    class="fa fa-exclamation-circle mr-2"
                    aria-hidden="true"
                  ></i>
                  <span class="" style="font-size: 13px; font-weight: 500"
                    >Sekolah menolak negosiasi<br class="mb-2"
                  /></span>
                  <!-- <span class="" style="font-size: 12px">
                    Sekolah tidak dapat menambahkan produk ke keranjang</span
                  > -->
                </template>
              </div>

              <div v-if="parentData.isDeal" class="alert alert-success">
                <i class="fa fa-exclamation-circle mr-2" aria-hidden="true"></i>
                <span class="" style="font-size: 13px; font-weight: 500"
                  >Penjual menyetujui negosiasi <br class="mb-2"
                /></span>
                <span class="" style="font-size: 12px">
                  Pembeli dapat menambahkan produk ke keranjang</span
                >
              </div>

              <div class="row no-gutters">
                <div class="col-md-12">
                  <div class="table-responsive card-body">
                    <table class="table">
                      <thead class="text-center" style="font-size: 9px">
                        <tr>
                          <!-- <th class="font-weight-bold">No</th> -->
                          <th class="font-weight-bold">Harga Nego</th>
                          <th class="font-weight-bold">Qty</th>
                          <th class="font-weight-bold">Harga Total</th>
                          <th class="font-weight-bold">Spek</th>
                          <th class="font-weight-bold">Harga Tanggapi</th>
                          <th class="font-weight-bold">Tanggal</th>
                        </tr>
                      </thead>
                      <tbody class="">
                        <tr
                          class="text-center"
                          v-for="(list, index) in listNegotiation"
                          :key="index"
                        >
                          <!-- <td style="font-size: 12px">1</td> -->
                          <td style="font-size: 12px">
                            {{ list.negoUnitPriceCurrencyFormat }}
                          </td>
                          <td style="font-size: 12px">{{ list.qty }}</td>
                          <td style="font-size: 12px">
                            {{ list.totalCurrencyFormat }}
                          </td>
                          <td style="font-size: 12px">{{ list.otherSpec }}</td>
                          <td style="font-size: 12px">
                            {{ list.priceResponseCurrencyFormat }}
                          </td>
                          <td style="font-size: 12px">{{ list.date }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <form
                  v-if="parentData.isOpenRespond"
                  class="mb-3"
                  action=""
                  id="form_tanggapan"
                  method="post"
                >
                  <h5 class="" style="font-size: 14px">Tanggapi ?</h5>
                  <button
                    type="button"
                    class="btn btn-primary"
                    data-toggle="modal"
                    data-target="#modal-sepakat"
                  >
                    <i class="far fa-arrow-alt-circle-up"></i>
                    Tanggapi
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger"
                    id="refuseNego"
                    @click="refuseNego"
                  >
                    <i class="fa fa-times"></i>
                    Tolak
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 dataCard">
        <div class="card card-user">
          <h5 class="title p-3">Customer</h5>
          <div class="image"></div>
          <div class="card-body">
            <div class="author">
              <img
                class="avatar border-gray"
                src="@/assets/upload/school3.png"
                alt="..."
              />
              <h5 class="title">{{ customer.name }}</h5>
            </div>
            <p class="description text-center">
              {{ customer.address }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from "axios";
// import { sleeper } from "/src/utils/sleeper.js";
import $ from "jquery";
import { getValue } from "vue-currency-input";

export default {
  components: {
    // InputNumber
  },
  data() {
    return {
      checkedData: false,
      parentData: {},
      customer: {},
      product: {},
      listNegotiation: {},
      modalRespond: {},
      paramId: 0,
      dataValue: 0,
      priceResponse: 0,
    };
  },
  watch: {
    dataValue() {
      console.log(getValue(this.$refs.harga_tanggapi));
      this.priceResponse = getValue(this.$refs.harga_tanggapi);
    },
  },
  created() {
    this.getResult();
  },
  mounted: function () {
    $(".dataCard").hide();
    $("#respondNego").on("click", function () {
      $("#ceklisSepakat").prop("checked");
    });
  },
  methods: {
    getResult() {
      this.paramId = this.$route.params.id;
      const detailNegoUrl = `seller/nego/${this.paramId}`;
      axios
        .get(detailNegoUrl)
        .then((res) => {
          return res.data.data;
        })
        .then((data) => {
          $(".dataCard").show();
          $(".forPlaceholder").hide();
          this.parentData = data;
          this.customer = data.customer;
          this.product = data.product;
          this.listNegotiation = data.listNegotiation;
          this.modalRespond = data.modalRespond;
        })
        .then(() => {
          if (this.modalRespond.isDisableWrapping) {
            $("#pembungkus_fee").attr("readonly", "");
          }

          if (this.modalRespond.isDisableInsurance) {
            $("#asuransi_persen").attr("readonly", "");
            $("#asuransi_fee").attr("readonly", "");
          }
        });
    },
    respondNego() {
      $("#modal-sepakat").modal("toggle");
      let checked = $("#ceklisSepakat").is(":checked")
        ? $("#ceklisSepakat").prop("checked", true)
        : $("#ceklisSepakat").prop("checked", false);
      $(".dataCard").hide();
      $(".forPlaceholder").show();
      let timerInterval = timerInterval;
      this.$swal.fire({
        title: "<span style='font-size:17px'>Negosiasi Diproses</span>",
        html: "Mohon Tunggu...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        width: 350,
        didOpen: () => {
          this.$swal.showLoading();
          timerInterval = setInterval(() => {
            const content = this.$swal.getContent();
            if (content) {
              const b = content.querySelector("b");
              if (b) {
                b.textContent = this.$swal.getTimerLeft();
              }
            }
          }, 100);
        },
      });
      axios
        .post("seller/nego/respond", {
          id: this.paramId,
          wrappingPrice: $("#pembungkus_fee").val(),
          insuranceOption: $("#asuransi_persen").find(":selected").val(),
          insurancePrice: $("#asuransi_fee").val(),
          priceResponse: this.priceResponse,
          otherSpec: $("#otherSpec").val(),
          isDeal: checked.prop("checked"),
        })
        .then(() => {
          this.$swal.close();
          this.getResult();
        });
    },
    refuseNego() {
      this.$swal
        .fire({
          title:
            "<span style='font-size:17px'>Anda Yakin untuk menolak negosiasi ini?</span>",
          html: "<span style='font-size:15px'>Setelah ditolak, pembeli tidak dapat menambahkan produk ini ke keranjang</span>",
          icon: "warning",
          showCancelButton: true,
          width: 450,
          confirmButtonColor: "#556ee6",
          cancelButtonColor: "#f46a6a",
          cancelButtonText: "Tidak",
          confirmButtonText: "Ya",
        })
        .then((result) => {
          if (result.isConfirmed) {
            $(".dataCard").hide();
            $(".forPlaceholder").show();
            let timerInterval = timerInterval;
            this.$swal.fire({
              title: "Negoisasi Ditolak",
              html: "Mohon Tunggu!",
              allowOutsideClick: false,
              allowEscapeKey: false,
              width: 350,
              didOpen: () => {
                this.$swal.showLoading();
                timerInterval = setInterval(() => {
                  const content = this.$swal.getContent();
                  if (content) {
                    const b = content.querySelector("b");
                    if (b) {
                      b.textContent = this.$swal.getTimerLeft();
                    }
                  }
                }, 100);
              },
            });
            this.paramId = this.$route.params.id;
            axios
              .put("seller/nego/refuse", {
                id: this.paramId,
              })
              .then(() => {
                this.getResult();
                this.$swal.close();
              });
          }
        });
    },
    /* eslint-disable no-unused-vars */
    checkSepakat: function (e) {
      this.checkedData === false ? true : false;
    },
  },
};
</script>